import { createSelector } from '../../dependencies';

export const activeCompanyIdSelector = state => state.activeCompany.id;

export const noActiveCompanyIdSelector = createSelector(
    activeCompanyIdSelector,
    activeCompanyId => activeCompanyId === null,
);
